import { HttpTypes } from '@/types';
import { AxiosInstance } from 'axios';

class StoreInformation {
  private readonly client: AxiosInstance;
  private routePath = '/sites';

  constructor(client: AxiosInstance) {
    this.client = client;
  }

  async detail() {
    const response = await this.client.get(`${this.routePath}/get-store`);
    return response.data;
  }

  async upsert(
    data: HttpTypes.AdminStoreInformationPayload
  ): Promise<HttpTypes.IResponse<HttpTypes.AdminStoreInformationResponse>> {
    const result = await this.client.put(`${this.routePath}/update-store`, data);
    return result.data;
  }
}

export default StoreInformation;
